import PresentationApi from '@/api/presentation'
import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'

const getters = {
  canUseCastingSync: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-41804-casting-sync')
  },
  canUseSyncOtherEvents: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-41804-casting-sync')
  },
}

const actions = {
  getPresentationDetailsByShareCodeAction: async ({ dispatch, rootGetters }, { shareCode, presentationId, payloadDataPresentation }) => {
    const [res] = await Promise.all([
      PresentationApi.getPresentationDetailsByShareCode(shareCode, payloadDataPresentation),
      dispatch('presentationAttributeModule/getPresentationAttributeAction', presentationId, { root: true }),
      dispatch('featureToggles/handlePresentationLoadFlagUnleashByShareCode', shareCode, { root: true }),
    ])
    if (rootGetters['featureToggles/canUseNewSlideMarketPlace']) {
      // Fire-and-forget pre-fetch; the action catches its own errors internally.
      dispatch('slideMarketplace/fetchMarketplaceSlideTypes', null, { root: true }).catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Failed to pre-fetch marketplace slide types:', err)
      })
    }
    return res
  },
}

export default {
  namespaced: true,
  getters,
  actions,
}
